import { useState } from 'react';
import type { GenerationEmailFieldProps } from './types';

const useGenerationEmailPicker = ({ value, onChange, disabled }: GenerationEmailFieldProps) => {
    const [showPicker, setShowPicker] = useState(false);
    const selectEmails = (emails: string[]) => {
        if (disabled) return;
        const seen = new Set<string>();
        const recipients = [...value.split(','), ...emails].map((email) => email.trim()).filter((email) => {
            const key = email.toLowerCase();
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        onChange(recipients.join(', '));
    };
    return {
        showPicker,
        openPicker: () => { if (!disabled) setShowPicker(true); },
        closePicker: () => setShowPicker(false),
        selectEmails,
    };
};

export default useGenerationEmailPicker;
